/* Click-to-play YouTube facade: snippets/sunday-youtube-facade.liquid.
   Nothing from YouTube loads until the visitor presses play. All handlers are
   delegated, so one copy of this file covers every facade on the page.

   Phones and tablets are the exception. iOS does not carry a tap on our button
   into the cross-origin player, so the swapped-in iframe sat on YouTube's own
   thumbnail and needed a second tap. On touch screens the player instead loads
   under the poster as the frame nears the viewport, the tap falls through to
   it, and the poster lifts once the player reports that it is playing. */
(function () {
  if (window.SundayYouTubeFacade) return;
  window.SundayYouTubeFacade = true;

  var EMBED_HOST = 'https://www.youtube-nocookie.com';
  var POSTER = '[data-sunday-yt] img[data-yt-poster]';
  var ARMED_IFRAME = '.sunday-yt.is-armed .sunday-yt__iframe';

  // Some videos have no maxres thumbnail: YouTube then serves a 120x90 grey
  // placeholder instead of an error. Fall back to the always-present hq still.
  function checkPoster(img) {
    if (img.dataset.ytChecked || !img.complete || img.naturalWidth === 0) return;
    img.dataset.ytChecked = '1';
    if (img.naturalWidth > 120) return;
    var frame = img.closest('[data-sunday-yt]');
    var id = frame && frame.getAttribute('data-video-id');
    if (id) img.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(id) + '/hqdefault.jpg';
  }

  document.querySelectorAll(POSTER).forEach(checkPoster);
  // load does not bubble, but it can be caught on the way down
  document.addEventListener('load', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches(POSTER)) checkPoster(target);
  }, true);

  // Warm the connection on intent (hover, focus, touch) so play starts faster.
  function warm(event) {
    var target = event.target;
    if (!target || !target.closest || !target.closest('[data-sunday-yt-play]')) return;
    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = EMBED_HOST;
    document.head.appendChild(link);
    document.removeEventListener('pointerover', warm);
    document.removeEventListener('focusin', warm);
    document.removeEventListener('touchstart', warm);
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('focusin', warm);
  document.addEventListener('touchstart', warm, { passive: true });

  // Every player runs with enablejsapi so it reports its state and time (see
  // listen). end= takes whole seconds only, so it is rounded up here as a
  // backstop and stopAtEnd pauses on the exact time.
  function createIframe(frame, params) {
    var id = frame.getAttribute('data-video-id');
    var start = parseInt(frame.getAttribute('data-video-start'), 10);
    var end = parseFloat(frame.getAttribute('data-video-end'));

    var iframe = document.createElement('iframe');
    iframe.className = 'sunday-yt__iframe';
    iframe.src = EMBED_HOST + '/embed/' + encodeURIComponent(id) + '?' + params +
      '&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin) + '&rel=0&playsinline=1' +
      (start > 0 ? '&start=' + start : '') +
      (end > 0 ? '&end=' + Math.ceil(end) : '');
    iframe.addEventListener('load', function () { listen(iframe); });
    iframe.title = frame.getAttribute('data-video-title') || 'YouTube video';
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    return iframe;
  }

  function sendCommand(iframe, message) {
    if (!iframe.contentWindow) return;
    message.id = 1;
    message.channel = 'widget';
    iframe.contentWindow.postMessage(JSON.stringify(message), EMBED_HOST);
  }

  // enablejsapi players report their state and time (about every 250 ms while
  // playing) once the parent says it is listening. The first hello can arrive
  // before the player is ready, so repeat it until the player answers.
  function listen(iframe) {
    var tries = 0;
    (function hello() {
      if (iframe.dataset.ytHeard || tries++ > 20) return;
      sendCommand(iframe, { event: 'listening' });
      setTimeout(hello, 250);
    })();
  }

  // Pause on the frame's end time, once: after that, play on is the visitor's call.
  function stopAtEnd(frame, iframe, time) {
    var end = parseFloat(frame.getAttribute('data-video-end'));
    if (!(end > 0) || iframe.dataset.ytStopped || iframe.dataset.ytState !== '1') return;
    clearTimeout(iframe.sundayStopTimer);
    var wait = (end - time) * 1000;
    if (wait <= 0) {
      // Just past it, stop; well past it (they skipped ahead), leave it be
      if (wait > -1000) sendCommand(iframe, { event: 'command', func: 'pauseVideo', args: [] });
      iframe.dataset.ytStopped = '1';
      return;
    }
    iframe.sundayStopTimer = setTimeout(function () {
      sendCommand(iframe, { event: 'command', func: 'pauseVideo', args: [] });
      iframe.dataset.ytStopped = '1';
    }, wait);
  }

  // ---------- touch screens: the player waits under the poster ----------

  function arm(frame) {
    if (!frame.getAttribute('data-video-id') || frame.querySelector('.sunday-yt__iframe')) return;
    var iframe = createIframe(frame, 'autoplay=0');
    // Kept out of the tab order and the accessibility tree until it plays: the
    // button on top stays the one control people reach.
    iframe.tabIndex = -1;
    iframe.setAttribute('aria-hidden', 'true');
    frame.insertBefore(iframe, frame.firstChild);
    frame.classList.add('is-armed');
  }

  function reveal(frame) {
    if (!frame || frame.classList.contains('is-playing')) return;
    var iframe = frame.querySelector('.sunday-yt__iframe');
    iframe.removeAttribute('tabindex');
    iframe.removeAttribute('aria-hidden');
    frame.classList.add('is-playing');
    var button = frame.querySelector('[data-sunday-yt-play]');
    if (button) button.remove();
  }

  function iframeFor(source) {
    var iframes = document.querySelectorAll('[data-sunday-yt] .sunday-yt__iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow === source) return iframes[i];
    }
    return null;
  }

  window.addEventListener('message', function (event) {
    if (event.origin !== EMBED_HOST || typeof event.data !== 'string') return;
    var iframe = iframeFor(event.source);
    if (!iframe) return;
    var data;
    try { data = JSON.parse(event.data); } catch (error) { return; }
    iframe.dataset.ytHeard = '1';
    var frame = iframe.closest('[data-sunday-yt]');
    var info = data.info && typeof data.info === 'object' ? data.info : {};
    var state = data.event === 'onStateChange' ? data.info : info.playerState;
    if (typeof state === 'number') {
      iframe.dataset.ytState = String(state);
      if (state !== 1) clearTimeout(iframe.sundayStopTimer);
    }
    // 1 playing, 3 buffering
    if ((state === 1 || state === 3) && frame.classList.contains('is-armed')) reveal(frame);
    if (typeof info.currentTime === 'number') stopAtEnd(frame, iframe, info.currentTime);
  });

  // Backup for the state message: a tap into the player moves focus into it.
  window.addEventListener('blur', function () {
    setTimeout(function () {
      var active = document.activeElement;
      if (active && active.matches && active.matches(ARMED_IFRAME)) reveal(active.closest('[data-sunday-yt]'));
    }, 0);
  });

  var touch = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  if (touch && !saveData && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        arm(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    document.querySelectorAll('[data-sunday-yt]').forEach(function (frame) { observer.observe(frame); });
  }

  // ---------- press play ----------

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[data-sunday-yt-play]');
    if (!button) return;
    var frame = button.closest('[data-sunday-yt]');
    if (!frame || !frame.getAttribute('data-video-id')) return;

    // Taps go straight to an armed player; this is a keyboard or screen
    // reader press on the button, so show the player and ask it to start.
    var armed = frame.classList.contains('is-armed') && frame.querySelector('.sunday-yt__iframe');
    if (armed) {
      reveal(frame);
      sendCommand(armed, { event: 'command', func: 'playVideo', args: [] });
      armed.focus();
      return;
    }

    var iframe = createIframe(frame, 'autoplay=1');

    // The poster stays underneath until the player paints over it.
    frame.appendChild(iframe);
    frame.classList.add('is-playing');
    button.remove();
    iframe.focus();
  });
})();
